<div id="questionario-page">
    <div class="container" *ngIf="formRicerca">
        <div>
            <div class="header-custom d-flex flex-column justify-content-center align-items-center">
                <div class="img-container">
                    <div class="img">
                        <img src="../../../assets/images/logo_unisa_color.png" alt="logo_unisa">
                    </div>
                    <h1>UNIVERSITÀ DEGLI STUDI DI SALERNOooo</h1>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center mt-5">
                    <h2>Opinioni Studenti - Questionari 1 e 3 ANVUR</h2>

                    <h3 class="mt-3">Valutazioni delle Attività Didattiche del Corso di Studi con dettagli per quesito</h3>
                </div>
            </div>
            <div class="body-custom p-4 bg-white">
                <form [formGroup]="formRicerca" class="form-row">
        
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="extStructPianoCogeIdPartenza" class="label"><strong>Anno Accademico</strong> &nbsp;</label>
                        <select  class="form-control" formControlName="annoAccademico"
                            id="annoAccademico" fullWidth (change)="findDipa(); loadTableSettings()">
                            <option [value]="anno.annoFormattato1" *ngFor="let anno of arrayAnni">{{anno.annoFormattato2}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="extStructPianoCogeIdPartenza" class="label"><strong>Studenti</strong> &nbsp;</label>
                        <select  class="form-control" formControlName="studente"
                            id="studente" fullWidth (change)="findDipa(); loadTableSettings()">
                            <option value="Frequentanti">Frequentanti</option>
                            <option value="Non frequentanti">Non Frequentanti</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="extStructPianoCogeIdPartenza" class="label"><strong>Dipartimento</strong> &nbsp;</label>
                        <select  class="form-control" formControlName="dipartimento"
                            id="dipartimento" fullWidth (change)="findCds(); loadTableSettings()">
                            <option value="*" hidden>Seleziona Dipartimento</option>
                            <option [value]="d.dipartimento" *ngFor="let d of listaDipa" [hidden]="d.dipartimento=='Tutti'">{{d.dipartimento}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="extStructPianoCogeIdPartenza" class="label"><strong>CDS</strong> &nbsp;</label>
                        <select  class="form-control" formControlName="cds"
                            id="cds" fullWidth (change)="loadTableSettings()">
                            <option value="*" hidden>Seleziona CDS</option>
                            <option [value]="cds.corsoDiStudi" *ngFor="let cds of listaCds" [hidden]="cds.corsoDiStudi=='Tutti'">{{cds.corsoDiStudi}}</option>
                        </select>
                    </div>
                </form>
                
                <div class="mt-3">
                    <p>
                        <strong>
                            Per ciascun quesito è stata calcolata la media aritmetica in base alla seguente scala di valutazione: "Decisamente NO"=1, "Più NO che SI"=2, "Più SI che NO"=3,
                            "Decisamente SI"=4.
                            Per una maggiore leggibilità è stato colorato lo sfondo dei valori indicanti le valutazioni medie adottando la seguente scala di giudizi: "INSODDISFACENTE" se
                            0 < valore <= 2.25, "CONDIZIONATO" se 2.25 < valore <= 2.5, "SODDISFACENTE" se 2.5 < valore<=3 e "PIENAMENTE POSITIVO" se 3 < valore <= 4.
                            La valutazione media delle Attività Didattiche viene colorata di rosa se 0 < valore <= 2.25 (giudizio "INSODDISFACENTE"), di giallo se 2.25 < valore <= 2.5 (giudizio
                            "CONDIZIONATO") di verde chiaro se 2.5 < valore <= 3 (giudizio "SODDISFACENTE") e se 3 < valore <= 4 (giudizio "PIENAMENTE POSITIVO").
                            La valutazione media del singolo quesito avrà sfondo colorato sulla base della seguente scala di giudizio: rosa se 0 < valore <= 2.25 (giudizio "INSODDISFACENTE"), giallo
                            se 2.25 < valore <= 2.5 (giudizio "CONDIZIONATO"), bianco se 2.5 < valore <= 3 (giudizio "SODDISFACENTE") e se 3 < valore <= 4 (giudizio "PIENAMENTE POSITIVO").
                            L'indice IS1 definisce quanti sono gli studenti soddisfatti per ogni studente insoddisfatto; l'indice IS2 definisce quanti sono gli studenti completamente soddisfatti per ogni
                            studente completamente insoddisfatto; l'indice IS3 rappresenta la percentuale degli studenti soddisfatti.
                            Gli indici sono calcolati nel seguente modo: IS1 = (DS+PSCN)/(DN+PNCS), IS2 = DS/DN, IS3 = (DS+PSCN)/Totale risposte (DS = Decisamente Sì, PSCN = Più Sì Che
                            No, PNCS = Più No Che Sì, DN = Decisamente No)
                        </strong>
                    </p>
                </div>

                <div style="overflow-x: auto;">
                    <ng2-smart-table *ngIf="settings" id="table" #table [settings]="settings" [source]="source">
                    </ng2-smart-table>
                </div>

                <div style="overflow-x: auto;" class="mt-5">
                    <h3>Valutazioni medie del Corso di Studio</h3>

                    <div *ngIf="formRicerca && formRicerca.get('annoAccademico').value && formRicerca.get('annoAccademico').value.trim() == '2023.24'">
                        <div class="d-flex flex-column pt-3">
                            <div class="d-flex justify-content-center align-items-center">
                                <h5 class="m-0"><strong>QUESITI</strong></h5>
                                <button nbButton (click)="toggleDomande()" class="btn btn-primary d-flex align-items-center ml-2">
                                    <i class="fas fs-20" [class]="{'fa-eye': viewDomande, 'fa-eye-slash': !viewDomande}" title="{{viewDomande?'nascondi' : 'visualizza'}} domande"></i>
                                </button>
                            </div>
                            <div class="table-domande" [class]="{'close': !viewDomande}">
                                <ng2-smart-table id="tableDomande" [settings]="settingsDomande" [source]="arrayDomande"></ng2-smart-table>
                            </div>
                        </div>
                        
                        <hr *ngIf="!viewDomande">
                    </div>

                    <ng2-smart-table *ngIf="settingsMedieCds" id="table" #tableMedieCds [settings]="settingsMedieCds" [source]="sourceMedieCds">
                    </ng2-smart-table>
                </div>
                
            </div>
        </div>
    </div>
</div>
